// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.card-subtitle {
  font-size: 14px;
  padding: 0px 15px;
}
.card-subtitle span fa-icon {
  margin-right: 4px;
}
.card-subtitle span:nth-child(1n+2) {
  margin-left: 8px;
}

.user-circle {
  font-size: 15px;
}

.icon-status {
  margin-top: 4px;
}
@media (max-width: 767px) {
  .icon-status {
    width: auto;
    padding: 3px;
  }
}
.icon-status.Verified {
  color: var(--undp-jtf-status-verified-color);
}
.icon-status.Verified .status-dot {
  background: var(--undp-jtf-status-verified-color);
}
.icon-status.Unverified {
  color: var(--undp-jtf-status-unverified-color);
}
.icon-status.Unverified .status-dot {
  background: var(--undp-jtf-status-unverified-color);
}
.icon-status.Responded {
  color: var(--undp-jtf-status-responded-color);
}
.icon-status.Responded .status-dot {
  background: var(--undp-jtf-status-responded-color);
}
.icon-status.Evaluated {
  color: var(--undp-jtf-status-evaluated-color);
}
.icon-status.Evaluated .status-dot {
  background: var(--undp-jtf-status-evaluated-color);
}
.icon-status.Pending {
  color: var(--undp-jtf-dark-bg-color);
}
.icon-status.Pending .status-dot {
  background: var(--undp-jtf-dark-bg-color);
}
.icon-status.InProgressVerification {
  color: var(--undp-jtf-secondary-color);
}
.icon-status.InProgressVerification .status-dot {
  background: var(--undp-jtf-secondary-color);
}
.icon-status.Recibido {
  color: var(--undp-jtf-dark-bg-color);
}
.icon-status.Recibido .status-dot {
  background: var(--undp-jtf-dark-bg-color);
}
.icon-status.Monitoreado {
  color: var(--undp-jtf-secondary-color);
}
.icon-status.Monitoreado .status-dot {
  background: var(--undp-jtf-secondary-color);
}
.icon-status.Analizado {
  color: var(--undp-jtf-status-verified-color);
}
.icon-status.Analizado .status-dot {
  background: var(--undp-jtf-status-verified-color);
}
.icon-status.Derivado {
  color: var(--undp-jtf-status-responded-color);
}
.icon-status.Derivado .status-dot {
  background: var(--undp-jtf-status-responded-color);
}
.icon-status.Cerrado {
  color: var(--undp-jtf-status-evaluated-color);
}
.icon-status.Cerrado .status-dot {
  background: var(--undp-jtf-status-evaluated-color);
}
.icon-status.mgmt-level-border {
  color: var(--undp-jtf-region-border-color);
}
.icon-status.mgmt-level-border .level-dot {
  background: var(--undp-jtf-region-border-color);
}

.report-date {
  margin-right: 0.5em;
}
@media (max-width: 767px) {
  .report-date {
    padding-top: 10px;
  }
}

.flex-subtitle-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
  margin-left: 4px;
  border-bottom: 1px solid #e6e6e6;
  gap: 1.5em;
  width: 100%;
}

.flex-subtitle {
  display: flex;
  gap: 0.5em;
  height: 100%;
}

.flex-bottom-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 5%;
}

.flex-bottom-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.flex-bottom-item-grow-1 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex-grow: 1;
}

.status-dot {
  height: 10px;
  width: 10px;
  opacity: 1;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.level-dot {
  height: 10px;
  width: 10px;
  opacity: 1;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.marg-top-7 {
  margin-top: 7px;
}

.flex-priority-wrapper {
  justify-content: flex-start;
  width: 40px;
}

.marg-right-priority-icon {
  margin-right: 2.5%;
}

.flex-status-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5em;
}

.vertical-line {
  padding-right: 21px;
  position: relative;
}

.vertical-line:after {
  content: "";
  position: absolute;
  right: 10%;
  border-right: 1px solid #d3d3d3;
  top: 10%;
  bottom: 10%;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-subtitle/post-subtitle.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,eAAA;EACA,iBAAA;AAEF;AAAI;EACE,iBAAA;AAEN;AAAI;EACE,gBAAA;AAEN;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;AACE;EAFF;IAGI,WAAA;IACA,YAAA;EAEF;AACF;AADE;EACE,4CAAA;AAGJ;AAFI;EACE,iDAAA;AAIN;AADE;EACE,8CAAA;AAGJ;AAFI;EACE,mDAAA;AAIN;AADE;EACE,6CAAA;AAGJ;AAFI;EACE,kDAAA;AAIN;AADE;EACE,6CAAA;AAGJ;AAFI;EACE,kDAAA;AAIN;AADE;EACE,oCAAA;AAGJ;AAFI;EACE,yCAAA;AAIN;AADE;EACE,sCAAA;AAGJ;AAFI;EACE,2CAAA;AAIN;AADE;EACE,oCAAA;AAGJ;AAFI;EACE,yCAAA;AAIN;AADE;EACE,sCAAA;AAGJ;AAFI;EACE,2CAAA;AAIN;AADE;EACE,4CAAA;AAGJ;AAFI;EACE,iDAAA;AAIN;AADE;EACE,6CAAA;AAGJ;AAFI;EACE,kDAAA;AAIN;AADE;EACE,6CAAA;AAGJ;AAFI;EACE,kDAAA;AAIN;AADE;EACE,0CAAA;AAGJ;AAFI;EACE,+CAAA;AAIN;;AAAA;EACE,mBAAA;AAGF;AAFE;EAFF;IAGI,iBAAA;EAKF;AACF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;AAKF;;AAFA;EACE,aAAA;EACA,UAAA;EACA,YAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;AAKF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAKF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAKF;;AAFA;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAKF;;AAFA;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAKF;;AAFA;EACE,eAAA;AAKF;;AAFA;EACE,2BAAA;EACA,WAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAKF;;AAFA;EACE,mBAAA;EACA,kBAAA;AAKF;;AAFA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,+BAAA;EACA,QAAA;EACA,WAAA;AAKF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../scss/variables';\n\n.card-subtitle {\n  font-size: 14px;\n  padding: 0px 15px;\n  span {\n    fa-icon {\n      margin-right: 4px;\n    }\n    &:nth-child(1n + 2) {\n      margin-left: 8px;\n    }\n  }\n}\n\n.user-circle {\n  font-size: 15px;\n}\n\n.icon-status {\n  margin-top: 4px;\n  @media (max-width: 767px) {\n    width: auto;\n    padding: 3px;\n  }\n  &.Verified {\n    color: var(--undp-jtf-status-verified-color);\n    .status-dot {\n      background: var(--undp-jtf-status-verified-color);\n    }\n  }\n  &.Unverified {\n    color: var(--undp-jtf-status-unverified-color);\n    .status-dot {\n      background: var(--undp-jtf-status-unverified-color);\n    }\n  }\n  &.Responded {\n    color: var(--undp-jtf-status-responded-color);\n    .status-dot {\n      background: var(--undp-jtf-status-responded-color);\n    }\n  }\n  &.Evaluated {\n    color: var(--undp-jtf-status-evaluated-color);\n    .status-dot {\n      background: var(--undp-jtf-status-evaluated-color);\n    }\n  }\n  &.Pending {\n    color: var(--undp-jtf-dark-bg-color);\n    .status-dot {\n      background: var(--undp-jtf-dark-bg-color);\n    }\n  }\n  &.InProgressVerification {\n    color: var(--undp-jtf-secondary-color);\n    .status-dot {\n      background: var(--undp-jtf-secondary-color);\n    }\n  }\n  &.Recibido {\n    color: var(--undp-jtf-dark-bg-color);\n    .status-dot {\n      background: var(--undp-jtf-dark-bg-color);\n    }\n  }\n  &.Monitoreado {\n    color: var(--undp-jtf-secondary-color);\n    .status-dot {\n      background: var(--undp-jtf-secondary-color);\n    }\n  }\n  &.Analizado {\n    color: var(--undp-jtf-status-verified-color);\n    .status-dot {\n      background: var(--undp-jtf-status-verified-color);\n    }\n  }\n  &.Derivado {\n    color: var(--undp-jtf-status-responded-color);\n    .status-dot {\n      background: var(--undp-jtf-status-responded-color);\n    }\n  }\n  &.Cerrado {\n    color: var(--undp-jtf-status-evaluated-color);\n    .status-dot {\n      background: var(--undp-jtf-status-evaluated-color);\n    }\n  }\n  &.mgmt-level-border {\n    color: var(--undp-jtf-region-border-color);\n    .level-dot {\n      background: var(--undp-jtf-region-border-color);\n    }\n  }\n}\n.report-date {\n  margin-right: 0.5em;\n  @media (max-width: 767px) {\n    padding-top: 10px;\n  }\n}\n\n.flex-subtitle-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 10px;\n  margin-left: 4px;\n  border-bottom: 1px solid #e6e6e6;\n  gap: 1.5em;\n  width: 100%;\n}\n\n.flex-subtitle {\n  display: flex;\n  gap: 0.5em;\n  height: 100%;\n}\n\n.flex-bottom-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-left: 5%;\n}\n\n.flex-bottom-item {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n\n.flex-bottom-item-grow-1 {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  flex-grow: 1;\n}\n\n.status-dot {\n  height: 10px;\n  width: 10px;\n  opacity: 1;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.level-dot {\n  height: 10px;\n  width: 10px;\n  opacity: 1;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.marg-top-7 {\n  margin-top: 7px;\n}\n\n.flex-priority-wrapper {\n  justify-content: flex-start;\n  width: 40px;\n}\n\n.marg-right-priority-icon {\n  margin-right: 2.5%;\n}\n\n.flex-status-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 0.5em;\n}\n\n.vertical-line {\n  padding-right: 21px;\n  position: relative;\n}\n\n.vertical-line:after {\n  content: '';\n  position: absolute;\n  right: 10%;\n  border-right: 1px solid #d3d3d3;\n  top: 10%;\n  bottom: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
